export default __webpack_public_path__ + "static/media/bit_of_aerosiderite.56a95d2f.png";